define('helperLearning-getUser',[],function() {
    'use strict';

    var getUser = function(obj) {
        return (obj && obj.hasOwnProperty('user') && obj.user && typeof obj.user === 'object') ? obj.user : null;
    };

    return getUser;

});

